
import EditCreative from './creative-info/edit-creative.vue';

export default {
  name: 'copyCreative.vue',

  components: {
    EditCreative: EditCreative
  },

  props: {
    id: {
      type: Number,
      required: true
    },

    createRequest: {
      type: Function
    },

    type: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        return ['normal', 'free'].indexOf(value) !== -1;
      }
    },

    text: {
      type: String
    }
  },

  computed: {
    innerText: function innerText() {
      if (this.text) return this.text;

      var utils = {
        normal: this.$t('playTurbo.versionlist.actionButton.copy'),
        free: this.$t('playTurbo.versionlist.actionButton.copyToPs')
      };
      return utils[this.type];
    }
  }
};